import { render, staticRenderFns } from "./PendingSelectionModal.vue?vue&type=template&id=8382d21a&scoped=true&"
import script from "./PendingSelectionModal.vue?vue&type=script&lang=js&"
export * from "./PendingSelectionModal.vue?vue&type=script&lang=js&"
import style0 from "./PendingSelectionModal.vue?vue&type=style&index=0&id=8382d21a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8382d21a",
  null
  
)

component.options.__file = "PendingSelectionModal.vue"
export default component.exports